import { render } from "./story-card.vue?vue&type=template&id=1a36c794"
import script from "./story-card.vue?vue&type=script&lang=js"
export * from "./story-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__